// Komponent wyświetlający aktywne filtry nad listingiem produktów
// @ts-nocheck

import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'react-bootstrap-icons';
import classnames from 'classnames';

import { IProductsFilter } from 'api/types';
import { XIcon } from 'assets/icons';

import styles from 'theme/pages/Products/components/ActiveFilters/ActiveFilters.module.scss';

interface IFilter {
  filter_id: string;
  filter_value: string;
}

interface IProps {
  queryFilters: IFilter[];
  filtersData?: IProductsFilter[];
  onRemoveFilter: (filterId: string, filterValue?: string) => void;
  onClearAll: () => void;
}

const ActiveFilters: FC<IProps> = ({ queryFilters, filtersData, onRemoveFilter, onClearAll }) => {
  const { t } = useTranslation();

  // Mapowanie filtrów do wyświetlenia z nazwami
  const activeFiltersDisplay = useMemo(() => {
    if (!filtersData || queryFilters.length === 0) return [];

    return queryFilters.map((queryFilter) => {
      const filter = filtersData.find((f) => f.id === queryFilter.filter_id);
      if (!filter) return null;

      // Dla range - pokazujemy zakres
      if (filter.type === 'range') {
        const [min, max] = queryFilter.filter_value.split(';');
        return {
          id: `${queryFilter.filter_id}-${queryFilter.filter_value}`,
          filterId: queryFilter.filter_id,
          filterValue: queryFilter.filter_value,
          label: `${filter.label}: ${min} - ${max}`,
          isRange: true
        };
      }

      // Dla singlechoice/bool - pokazujemy nazwę wartości; gdy label === wartość, tylko label (bez "Bez SUP: Bez SUP")
      const value = filter.values?.find((v) => v.value === queryFilter.filter_value);
      const valueName = value?.name || queryFilter.filter_value;
      const label =
        valueName && valueName !== filter.label
          ? `${filter.label}: ${valueName}`
          : filter.label;
      return {
        id: `${queryFilter.filter_id}-${queryFilter.filter_value}`,
        filterId: queryFilter.filter_id,
        filterValue: queryFilter.filter_value,
        label,
        isRange: false
      };
    }).filter(Boolean);
  }, [queryFilters, filtersData]);

  if (activeFiltersDisplay.length === 0) {
    return null;
  }

  return (
    <div className={classnames(styles.componentWrapper, 'StylePath-Pages-Products-components-ActiveFilters')}>
      <div className={styles.filtersList}>
        {activeFiltersDisplay.map((filter) => (
          <div key={filter.id} className={styles.filterTag}>
            <span className={styles.filterLabel}>{filter.label}</span>
            <button
              className={styles.removeButton}
              onClick={() => onRemoveFilter(filter.filterId, filter.filterValue)}
              aria-label={t('Usuń filtr')}>
              <X />
            </button>
          </div>
        ))}
        <button className={styles.clearAllButton} onClick={onClearAll}>
          {t('Wyczyść wszystko')} <XIcon />
        </button>
      </div>
    </div>
  );
};

export default ActiveFilters;

